import { cn } from "@/lib/utils";
import usePlanInfoStore from "@/store/zustand/planInfoStore";
import React from "react";
import { useUsageMessage } from "@/hooks/pricing/useUsageMessage";
import { useUsageLimits } from "@/hooks/pricing/useUsageLimits";
import { useSession } from "@clerk/clerk-react";
interface Props {
  isForChat?: boolean;
}

const UsageIndicator: React.FC<Props> = ({ isForChat = false }) => {
  const { usageMessage } = useUsageMessage();
  const { remainingUsage } = useUsageLimits();

  const setShowUpgradeModal = usePlanInfoStore(
    (state) => state.setShowUpgradeModal,
  );

  const { session } = useSession();
  const refreshPlanInfo = usePlanInfoStore((state) => state.refreshPlanInfo);

  // Only proceed if there's a usage message and supabase is initialised
  const shouldShowIndiCator =
    session && usageMessage && usageMessage.length > 0;

  return (
    <div
      className="flex justify-between items-center gap-4 px-2 py-1 border-2 bg-secondary-n-1000 border-[#0000] p-3 [background:padding-box_var(--bg-color),border-box_var(--border-color)]"
      style={{
        borderWidth: "1px 1px 0px 1px",
        borderStyle: "solid",
        borderTopLeftRadius: "var(--radius-md)",
        borderTopRightRadius: "var(--radius-md)",
        visibility: shouldShowIndiCator ? "visible" : "hidden",
        // @ts-ignore just css bullshittery move along
        "--border-color":
          "linear-gradient(91deg, #6F55F2 0%, #C1B6F9 21.02%, #2F3035 48.54%)",

        "--bg-color": shouldShowIndiCator
          ? "linear-gradient(#131519, #131519)"
          : "transparent",
      }}
    >
      <span className="text-xs text-secondary-n-50">{usageMessage}</span>
      <button
        className={cn(
          "text-xs font-medium text-primary-n-500 hover:text-primary-n-400",
          remainingUsage.hasPromptsLeft === false &&
            "text-primary-n-500 hover:text-primary-n-400",
        )}
        onClick={() => {
          if (shouldShowIndiCator) {
            setShowUpgradeModal(true);
            refreshPlanInfo(session);
          }
        }}
      >
        Upgrade
      </button>
    </div>
  );
};

export default UsageIndicator;
